// src/utils.js

// --- Funções de Limpeza e Validação ---

export function limparNumeros(valor) {
    return valor ? String(valor).replace(/\D/g, '') : '';
}

export function validarCPF(cpf) {
    cpf = limparNumeros(cpf);
    if (!cpf || cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
        return false;
    }
    let soma = 0; let resto;
    for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;
    return true;
}

export function validarCNPJ(cnpj) {
    cnpj = limparNumeros(cnpj);
    if (!cnpj || cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(1))) return false;
    return true;
}

// --- Funções de Formatação para Input (Máscara) ---

export function formatarTelefoneInput(telefone) {
    const numeros = limparNumeros(telefone);
    if (numeros.length <= 2) return `(${numeros}`;
    if (numeros.length <= 6) return `(${numeros.slice(0, 2)}) ${numeros.slice(2)}`;
    if (numeros.length <= 10) return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 6)}-${numeros.slice(6)}`;
    return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7, 11)}`; // Para 11 dígitos
}

export function formatarCPFInput(cpf) {
    const numeros = limparNumeros(cpf);
    if (numeros.length <= 3) return numeros;
    if (numeros.length <= 6) return `${numeros.slice(0, 3)}.${numeros.slice(3)}`;
    if (numeros.length <= 9) return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(6)}`;
    return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(6, 9)}-${numeros.slice(9, 11)}`;
}

export function formatarCPFExibicao(cpf) {
    if (!cpf) return '-';
    const numeros = limparNumeros(cpf); // Garante que está trabalhando só com números
    if (numeros.length === 11) {
        return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(6, 9)}-${numeros.slice(9, 11)}`;
    }
    return numeros; // Retorna como está se não tiver 11 dígitos
}

export function formatarCNPJInput(cnpj) {
    const numeros = limparNumeros(cnpj);
    if (numeros.length <= 2) return numeros;
    if (numeros.length <= 5) return `${numeros.slice(0, 2)}.${numeros.slice(2)}`;
    if (numeros.length <= 8) return `${numeros.slice(0, 2)}.${numeros.slice(2, 5)}.${numeros.slice(5)}`;
    if (numeros.length <= 12) return `${numeros.slice(0, 2)}.${numeros.slice(2, 5)}.${numeros.slice(5, 8)}/${numeros.slice(8)}`;
    return `${numeros.slice(0, 2)}.${numeros.slice(2, 5)}.${numeros.slice(5, 8)}/${numeros.slice(8, 12)}-${numeros.slice(12, 14)}`;
}

// --- Funções de Formatação para Exibição ---

export function formatarTelefoneExibicao(telefone) {
    if (!telefone) return '-';
    telefone = limparNumeros(telefone); // Garante que está trabalhando só com números
    if (telefone.length === 11) return `(${telefone.substring(0, 2)}) ${telefone.substring(2, 7)}-${telefone.substring(7)}`;
    if (telefone.length === 10) return `(${telefone.substring(0, 2)}) ${telefone.substring(2, 6)}-${telefone.substring(6)}`;
    return telefone; // Retorna como está se não for 10 ou 11 dígitos
}

export function formatarDataHora(dataIso) {
    if (!dataIso) return '-';
    try {
        const dataObj = new Date(dataIso);
        if (isNaN(dataObj.getTime())) return 'Inválida';
        const opcoes = {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
            // timeZone: 'America/Sao_Paulo' // Ajuste o fuso se necessário
        };
        return dataObj.toLocaleString('pt-BR', opcoes);
    } catch (e) {
        console.error("Erro ao formatar data:", dataIso, e);
        return 'Erro Data';
    }
}